import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Navigator from "../../../Common/layouts/Navigator/Navigator";
import {
  selectConfigAxes,
  selectRetrofitConfiguration,
  selectShowAxisPopup,
  selectRetrofitSteps,
  setCurrentStep,
  showSnackbar,
  selectNewAxisMode,
  selectSizingSelected
} from "../../../Retrofit/store/slices/retrofit";
import { logEvent } from "../../../Common/utils/api/api";
import useCheckMobileScreen from "../../../Common/utils/useCheckMobileScreen";
import SelectStep from "../SelectStep/SelectStep";
import Specify from "../Specify/Specify";
import SharedSurvey from "../../components/Survey/SharedSurvey";
import { selectEventsData, updateConfiguration } from "../../../Common/store/slices/common";

const SpecifySelect = () => {
  const dispatch = useDispatch();
  const isMobile = useCheckMobileScreen();
  const steps = useSelector(selectRetrofitSteps);
  const configAxes = useSelector(selectConfigAxes);
  const configuration = useSelector(selectRetrofitConfiguration);

  const eventsData = useSelector(selectEventsData);
  const newAxisMode = useSelector(selectNewAxisMode);

  const continueAction = () => {
    if (configAxes.every((axis) => axis.bundle.motorReference)) {
      dispatch(setCurrentStep(steps.SAVEANDSHARE));
      dispatch(updateConfiguration());
      logEvent(eventsData.locale, eventsData.types.save, eventsData.tags.none, configuration?.configId);
    } else {
      dispatch(showSnackbar({ id: "MISSING_BUNDLE_FINALIZE" }));
      logEvent(eventsData.locale, eventsData.types.unfinishedConf, eventsData.tags.none, configuration?.configId);
    }
  };

  const previousAction = () => {
    dispatch(setCurrentStep(steps.APPLICATION_SETTINGS));
    dispatch(updateConfiguration());
  };

  // eslint-disable-next-line no-unused-vars
  const showAxisPopup = useSelector(selectShowAxisPopup);
  const isSizingSelected = useSelector(selectSizingSelected);
  return (
    <div>
      <Specify />
      <SelectStep />
      {isMobile && !newAxisMode && <Navigator continueAction={continueAction} previousAction={previousAction} />}
      {!isMobile && !isSizingSelected && (
        <Navigator
          continueButtonDisabled={!configAxes.every((axis) => axis.bundle.motorReference)}
          continueAction={continueAction}
          previousAction={previousAction}
        />
      )}
      <SharedSurvey />
    </div>
  );
};

export default SpecifySelect;
